import _ from 'lodash';
import filters from '../core/filters';
import translate from '../core/tools/translate';
import environment from '../environment';
import { CoreControl } from './CoreControl';
import { VectorType } from './VectorType';
import api from '../api';
import { ContextEnum } from '../../enuns/context.enum';
import { FeaturePermission } from '../../constants/feature.permission.helper';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class PGTSControl extends CoreControl {
    constructor () {
        super({ name: 'PGTS' });

        this.select = this.select.bind(this);
        this.createFilter = this.createFilter.bind(this);
        this._filterCallback = this._filterCallback.bind(this);

        this._instance = null;
    }

    static getInstance () {
        if (!PGTSControl._instance) {
            PGTSControl._instance = new PGTSControl();
        }

        return PGTSControl._instance;
    }

    init () {
        const values = {
            help: translate(`Help.${this.options.name}`),
            id: 'layer-pgts',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            filter: isAuthorized(FeaturePermission.LAYER_GENERAL.pgtsFilter) ? {
                enable: isAuthorized(FeaturePermission.LAYER_GENERAL.pgtsFilter),
                click: this.createFilter
            } : false,
            type: 'vector-points'
        };

        const dataSource = _.map(environment.get('CONFIG.FILTERS.PGTS'), t => ({ text: t.nome, value: t.id }));

        // Dealers with 1 brand dont need a dropdown
        values.dropdown = [];
        if (_.size(dataSource)) {
            values.dropdown.push({
                name: 'type',
                custom: _.size(dataSource) > 3,
                dataSource,
                change: this.select
            });
        }

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    _change(e) {
        try {
            if (e.checked) {
                this.createFilter();
            } else {
                filters.close();
            }
        } catch (err) {
            console.log('ERROR: ', err);
        }
        super._change(e);
    }

    select (value) {
      const dataSource = _.map(environment.get('CONFIG.FILTERS.PGTS'), t => ({ text: t.nome, value: t.id }));
      api.general.log.action(ContextEnum.LayerPgts, `Tema: ${dataSource.find(x => x.value === Number(value)).text}`);
        this.getLayer().setOptions({
            remote: {
                params: {
                    idsTipos: value
                }
            }
        });
        if (this.check() && this.getLayer().visible()) {
            return this.getLayer().redraw();
        }
    }

    createFilter() {
        this.filterOptions = {
            ... {
                id: `${_.kebabCase(this.options.name)}-filter-id`,
                label: translate(`Common.${this.options.name}`),
                type: _.lowerCase(this.options.name),
                onSubmit: this._filterCallback
            }
        };

        filters.create(this.filterOptions);
    }

    _filterCallback(values) {
        const layer = this.getLayer();
        const { params } = layer.options.remote;

        const selectedFilters = {
            sizeCompany: values.sizeCompany ? _.isArray(values.sizeCompany.value) && _.size(values.sizeCompany.value) ? values.sizeCompany.value : [] : []
        };

        params.idsCompanySize = values.sizeCompany.value;

        layer.setOptions({
            remote: {
                params
            }
        });

        api.general.log.action(environment._getContextEnum(this.options.name), 'Filtro', JSON.stringify(values));

        if (!this.check()) {
            this.check(true);
        }

        layer.redraw();
    }
}

export default PGTSControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/PGTSControl.js